module.exports = __webpack_public_path__ + "static/media/interview-key.4852f445.PNG";